/* cl-card.js — card de produto do tema dele (snippet cl-card, cards.py).
   - fotos: no desktop o hover percorre as fotos (cycle_images dele) e a paginacao acompanha;
     no toque, arrastar para o lado troca a foto
   - "Ajout rapide": abre o menu de tamanhos (hover no desktop, toque no mobile); cada tamanho e um
     form /cart/add que a gaveta (cl-kcart.js) intercepta */
(function () {
  'use strict';
  function show(item, i) {
    var imgs = item.querySelectorAll('[data-grid-image]'), pages = item.querySelectorAll('[data-grid-page]');
    if (!imgs.length) return;
    i = ((i % imgs.length) + imgs.length) % imgs.length;
    imgs.forEach(function (im, k) { im.classList.toggle('clx-is-active', k === i); if (k === i) im.setAttribute('data-grid-current-image', 'true'); else im.removeAttribute('data-grid-current-image'); });
    pages.forEach(function (p, k) { p.classList.toggle('clx-is-active', k === i); p.style.setProperty('--width', k === i ? '100%' : '0%'); });
    item._i = i;
  }
  function popover(item, open) {
    var pop = item.querySelector('[role="popover"]'), btn = item.querySelector('button[title="Ajout rapide"]');
    if (!pop) return;
    pop.style.display = open ? '' : 'none';
    // as camadas internas do menu (x-show do Alpine dele) tambem nascem com display:none
    pop.querySelectorAll('[data-cl-xshow], [style*="display: none"]').forEach(function (el) {
      el.setAttribute('data-cl-xshow', ''); el.style.display = open ? '' : 'none';
    });
    item.classList.toggle('cl-qa-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  var hoverable = window.matchMedia('(hover: hover)').matches;
  document.addEventListener('mouseover', function (e) {
    if (!hoverable) return;
    var item = e.target.closest && e.target.closest('.product-grid-item__content.is-slideshow');
    if (!item || item._cyc) return;
    var imgs = item.querySelectorAll('[data-grid-image]');
    if (imgs.length < 2) return;
    item._cyc = setInterval(function () { show(item, (item._i || 0) + 1); }, 1100);
    show(item, 1);
    item.addEventListener('mouseleave', function lv() {
      clearInterval(item._cyc); item._cyc = null; show(item, 0); popover(item, false);
      item.removeEventListener('mouseleave', lv);
    });
  });
  document.addEventListener('mouseover', function (e) {
    if (!hoverable) return;
    var b = e.target.closest && e.target.closest('button[title="Ajout rapide"]');
    if (b) popover(b.closest('.product-grid-item__content'), true);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[title="Ajout rapide"]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var it = b.closest('.product-grid-item__content'); popover(it, !it.classList.contains('cl-qa-open'));
      return;
    }
    if (!e.target.closest('[role="popover"]')) document.querySelectorAll('.product-grid-item__content.cl-qa-open').forEach(function (it) { popover(it, false); });
  }, true);
  // toque: arrastar as fotos
  var tx = null, ty = null, tItem = null;
  document.addEventListener('touchstart', function (e) {
    var it = e.target.closest && e.target.closest('.product-grid-item__content.is-slideshow [data-grid-images]');
    if (!it) return;
    tItem = it.closest('.product-grid-item__content'); tx = e.touches[0].clientX; ty = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!tItem) return;
    var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty, it = tItem; tItem = null;
    if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      show(it, (it._i || 0) + (dx < 0 ? 1 : -1));
      it._swiped = Date.now();
    }
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.product-grid-item__content [data-grid-link]');
    if (a) { var it = a.closest('.product-grid-item__content'); if (it._swiped && Date.now() - it._swiped < 400) { e.preventDefault(); } }
  }, true);
})();
